import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'environment';
import {
  HttpClient,
  HttpRequest,
  HttpHeaders,
  HttpParams,
  HttpUrlEncodingCodec,
  HttpResponse,
  HttpEventType,
} from '@angular/common/http';
import { Cookie } from 'ng2-cookies';

export interface ApiParameters {
  name?: string;
  // method defaults to 'GET', options: 'POST'|'post'|'PUT'|'put'|'PATCH'|'patch'|'DELETE'|'delete'|'GET'|'get',
  method?: string;
  headers?: { [key: string]: string };
  oParam?: { [key: string]: any }; // a.k.a query parameters
  body?: any;
  prefix?: string;
  suffix?: string;
  path?: string;
  responseType?: any;
  reportProgress?: boolean;
  isStatusTracker?: boolean;
  isNonFedUserAccessEntities?: boolean;
  tempPath?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WrapperService {
  public APIs: any = {
    aac: '/aac/v1',
    aac2: '/v2/aac',
    access: '/rms/v2/access',
    accessstatus: '/rms/v1/accessstatus',
    alerts: '/alert/v2/alerts',
    allAlerts: '/alert/v2/alerts/allAlerts',
    'apiKey24hrsCheck-get': '/apikeyregistrationservice/v1/apikey/user/',
    'apikey-remove': '/apikeyregistrationservice/v2/apikey/user/',
    'apikey-get': '/apikeyregistrationservice/v2/apikey',
    'register-apikey': '/apikeyregistrationservice/v1/apikey',
    'send-otp': '/rms/v1/otp/send',
    'enter-otp': '/rms/v1/otp/apikey',
    awards: '/view-details/v1/api/award',
    bioProductsFor: '/view-details/v2/api/entity/bio-preferred-products',
    cms: '/content/v1',
    comment: '/comment/v1',
    'contract-data-featureToggle': '/watchlistservice/v1/api/toggle/enablecontractdata',
    contractOpportunity: '/opps/v2',
    contractOpportunityV4: '/opps/v4',
    databank: '/databank/v1',
    deleteDownload: '/logging-service/v1/delete',
    domainDefinition: '/rms/v1/domaindefinition',
    downloadFile: '/logging-service/v1/file-download',
    entities: '/view-entity-details/v1/api/entity',
    entity: '/rms/v1/autocomplete',
    'entity-information': '/entity-information/v1/api',
    'entity-uei': '/view-entity-details/v2/api/entityuei',
    entityRegistration: '/view-entity-details/v2/api/entity',
    entityRegistrationV3: '/view-entity-details/v3/api/entity',
    exclusions: '/view-exclusion-details/v1/api/exclusion',
    'exclusions-api': '/view-exclusion-details/v2/exclusions',
    'exclusions-new': '/view-exclusion-details/v2/api/exclusion',
    exclusion: '/view-exclusion-details/v3/api/exclusion/',
    featureToggle: '/feature/v1/read',
    featuredSearch: '/sgs/v1/search/featured',
    federalCreateOrg: '/federalorganizations/v1/organization',
    federalHierarchy: '/federalorganizations/v1/organizations',
    federalHierarchyActive: '/federalorganizations/v1/activeorganizations',
    feedback: '/feedback/v1',
    fh: '/federalorganizations/v1',
    fh2: '/federalorganizations/v2',
    fhFeatureToggle: '/federalorganizations/feature/v1/read',
    fileExtractDownload: '/fileextractservices/v1/api/download',
    fileExtracts: '/fileextractservices/v1/api/listfiles',
    'follow-contract-data-featureToggle': '/watchlistservice/v1/api/toggle/followenablecontractdata',
    functions: '/rms/v1/functions',
    gettoggeServices: '/feature/v1/',
    iam: '/iam/auth/v4',
    location: '/locationservices/v1/api',
    location2: '/locationservices/v2/api',
    locationmock: '/locationservicesmock/v1/api',
    logout: '/signout',
    modernizedWageDetermination: '/wdol',
    myFeeds: '/feeds/v1',
    mydownloads: '/logging-service/v1/mydownloads-info',
    opportunity3: '/opps/v3',
    permissions: '/rms/v1/permissions',
    preferences: '/preferences',
    program: '/fac/v1/programs',
    reRun: '/logging-service/v1/rerun',
    relatedEntities: '/entity-hierarchy/v1/api/exclusions-hierarchy',
    relatedEntitiesV2: '/entity-hierarchy/v2/api/exclusions-hierarchy',
    relatedPrograms: '/fac/v1/programs/relatedprograms',
    'report-download': '/ui-export-auth',
    reportFavorites: '/preferences/v1/favorites',
    reportSavedSearch: '/preferences/v1/report',
    requestaccess: '/rms/v1/requestaccess',
    rms: '/rms/v1',
    rms2: '/rms/v2',
    sap: '/iam/cws/api/system-account-passwords',
    savedSearch: '/preferences/v1/search',
    scrSubContractor: '/view-details/v2/api/entity/scr-sub-contractors',
    search: '/sgs/v1/search',
    searchDictionaries: '/sgs/v1/dictionaries',
    session: '/iam/rms/v3/session',
    subscriptions: '/watchlistservice/v1/api/subscriptions',
    suggestions: '/sgs/v1/suggestions',
    termsconditions: '/iam/cws/v1/applications/cwsterms-audit',
    'ui-export': '/ui-export-auth',
    'ui-export2': '/ui-export-service/v2/export-auth-download',
    uiroles: '/rms/v2/uiroles',
    unseenRecords: '/logging-service/v1/unseen-records',
    userByEmail: '/rms/v1/userpickerdetails/',
    userFilter: '/rms/v1/userpicker/filter/',
    userPicker: '/picker/v2/users',
    userSearch: '/rms/v1/userpickerdetails/',
    'view-details': '/view-details/v1/api/entities',
    wageDetermination: '/wdol/v1',
    watchlist: '/watchlistservice/v1/api/recorddetail',
    requests: '/feeds/v2/requests',
    'email-subscription': '/notification/v1/email/subscription',
    session4: '/iam/rms/v4/session',
    escalation: '/escalation',
    defaultEmailSubscriptionNotifications: '/assets/deafult-email-subscription-notifications.json',
    updateFrequencyByDomain: '/watchlistservice/v1/api/updateFrequencyByDomain',
    deleteuser: '/rms/v1/deleteuser',
    userAgreement: '/rms/v1/agreements/',
  };

  constructor(private _httpClient: HttpClient) {}

  call(
    oApiParam: ApiParameters,
    convertToJSON: boolean = true,
    queryEncoder: HttpUrlEncodingCodec = null,
    authenticatedCall: boolean = true,
    skipAPIKeyParam: boolean = false,
  ) {
    return this.httpCall(oApiParam, convertToJSON, queryEncoder, authenticatedCall, skipAPIKeyParam);
  }

  staticHttpResponseCall(name) {
    return this._httpClient.get(
      window.location.hostname === 'localhost' ? this.APIs[name] : '/workspace/profile' + this.APIs[name],
    );
  }
  httpCall(
    oApiParam: ApiParameters,
    convertToJSON: boolean = true,
    queryEncoder: HttpUrlEncodingCodec = null,
    authenticatedCall: boolean = true,
    skipAPIKeyParam: boolean = false,
  ) {
    const method: string = oApiParam.method || 'GET';
    let responseType = oApiParam.responseType ? oApiParam.responseType : 'json';
    if (!convertToJSON && !oApiParam.responseType) {
      responseType = 'text';
    }

    let headers = new HttpHeaders(oApiParam.headers);
    let params = new HttpParams({
      encoder: queryEncoder,
    });

    // add API-Umbrella key only in local development
    //if (!environment.production) {
    if (!skipAPIKeyParam) {
      params = params.set('api_key', environment['API_UMBRELLA_KEY']);
    }
    //}

    // adding random parameter to fix IE caching issue
    if (method.toUpperCase() === 'GET' && !oApiParam.isNonFedUserAccessEntities) {
      params = params.set('random', new Date().getTime().toString());
    }

    // Adding X-Auth-Token to all calls
    if (!headers.has('X-Auth-Token') && authenticatedCall && Cookie.check('SESSION')) {
      headers = headers.append('X-Auth-Token', Cookie.get('SESSION'));
    }

    // loop through oParam & add them as request parameter
    for (const key in oApiParam.oParam) {
      let val =
        typeof oApiParam.oParam[key] === 'object' && oApiParam.oParam[key] != null
          ? JSON.stringify(oApiParam.oParam[key])
          : oApiParam.oParam[key];
      if (val === undefined || val === null) {
        val = '';
      }
      params = params.set(key, val);
    }

    const prefix = oApiParam.prefix || '';
    const middle = oApiParam.name ? this.APIs[oApiParam.name] : '';
    const suffix = oApiParam.suffix || '';
    let path = '';
    if (oApiParam.isStatusTracker) {
      path = oApiParam.path
        ? `${environment['ENTITY_STATUS_TRACKER_URL']}${oApiParam.path}`
        : `${environment['ENTITY_STATUS_TRACKER_URL']}${prefix}${middle}${suffix}`;
    } else {
      let API_UMBRELLA_URL: string = environment['API_UMBRELLA_URL'];
      if (oApiParam.tempPath === 'apikey-delete' && !API_UMBRELLA_URL.includes('api/')) {
        const hostSp: string[] = API_UMBRELLA_URL.split('https://');
        if (hostSp.length > 1) {
          const domainPath = hostSp[1].split('/');
          domainPath.splice(1, 0, 'api');
          API_UMBRELLA_URL = 'https://' + domainPath.join('/');
        }
      }
      path = oApiParam.path ? `${API_UMBRELLA_URL}${oApiParam.path}` : `${API_UMBRELLA_URL}${prefix}${middle}${suffix}`;
    }

    // UNCOMMENT the following if statement to point to local WATCHLIST
    // if(path.includes('/watchlist') || path.includes('/subscriptions')) {
    //   path = 'http://localhost:8080' + (oApiParam.path ? oApiParam.path : prefix + middle + suffix);
    //   console.log("Hitting endpoint -> " + path);
    // }

    const optionsObj: any = {
      headers: headers,
      observe: convertToJSON ? 'body' : 'response',
      reportProgress: oApiParam.reportProgress,
      params: params,
      body: oApiParam.method === 'DELETE' ? oApiParam.body : null,
      responseType: responseType,
      withCredentials: false,
    };

    const addUnderscoreBody = (res) => {
      // legacy http code fix
      if (res && typeof res == 'object') {
        if (optionsObj.observe === 'response') {
          res['_body'] = res['body'];
        }
        res.json = () => res.body;
      }
      return res;
    };
    if (oApiParam.reportProgress) {
      const oRequest = new HttpRequest(<any>oApiParam.method, path, oApiParam.body, optionsObj);

      return this._httpClient.request(oRequest).pipe(
        map((res: HttpResponse<any>) => {
          if (res.type == HttpEventType.Response && convertToJSON) {
            return res.body;
          }
          return res;
        }),
      );
    } else {
      if (oApiParam && oApiParam.method && oApiParam.method.toUpperCase()) {
        oApiParam.method = oApiParam.method.toUpperCase();
      }
      switch (oApiParam.method) {
        case 'GET':
          return this._httpClient.get(path, optionsObj);
        case 'POST':
          return this._httpClient.post(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
        case 'DELETE':
          return this._httpClient.delete(path, optionsObj);
        case 'PATCH':
          return this._httpClient.patch(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
        case 'PUT':
          return this._httpClient.put(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
        case 'OPTIONS':
          return this._httpClient.options(path, optionsObj);
        default:
          return this._httpClient.get(path, optionsObj).pipe(map(addUnderscoreBody));
      }
    }
  }
}
